import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useAuth } from '../../contexts/authContext';
import { PreAwardHandoffPanel } from './PreAwardHandoffPanel';
export function ConvertToPreAwardDialog({ open, onOpenChange, project }) {
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        open: open,
        onOpenChange: onOpenChange,
        title: "Send submitted bid to Pre-Award",
        size: "xl",
        testId: Testids.preAward.convertDialog,
        children: open && /*#__PURE__*/ _jsx(AccountHandoff, {
            proposalProjectId: project.projectId
        })
    });
}
function AccountHandoff({ proposalProjectId }) {
    const { user } = useAuth();
    return /*#__PURE__*/ _jsx(PreAwardHandoffPanel, {
        proposalProjectId: proposalProjectId
    }, JSON.stringify([
        user?.tenant_id,
        user?.id,
        proposalProjectId
    ]));
}
